import { ReservationDto, SeatedReservationDto } from 'gleblu-socket-api';
import moment from 'moment-timezone';

import { AnyReservation, SeatedReservation } from '../interfaces/reservation/Reservation';
import { fromDto as fromReservationEventDto, toDto as toReservationEventDto } from './ReservationEventAdapter';
import { fromDto as fromReservationGuestDto, toDto as toReservationGuestDto } from './ReservationGuestAdapter';
import { fromDto as fromReservationSeatingDto, toDto as toReservationSeatingDto } from './ReservationSeatingAdapter';

export function fromDto(reservationDto: ReservationDto | SeatedReservationDto): AnyReservation {
  const { uuid, placeUuid, date, realTime, numberOfGuests, layoutType, guest: guestDto, reservationState, origin, metadata, specialRequest } = reservationDto;
  const { seating, reservationEvent, timeInterval } = reservationDto as SeatedReservationDto;

  const reservation: AnyReservation = {
    uuid,
    placeUuid,
    date: moment(date),
    realTime,
    numberOfGuests,
    layoutType,
    reservationState,
    origin,
    guest: fromReservationGuestDto(guestDto),
    seating: seating ? fromReservationSeatingDto(seating) : undefined,
    timeInterval: timeInterval
      ? {
          startDate: moment(timeInterval.startDate),
          endDate: moment(timeInterval.endDate),
        }
      : null,

    reservationEvent: reservationEvent ? fromReservationEventDto(reservationEvent) : undefined,
    specialRequest,
  };

  if (metadata) {
    reservation.metadata = {
      createdAt: metadata.createdAt,
      updatedAt: metadata.updatedAt,
      createdBy: metadata.createdBy ? metadata.createdBy : null,
      updatedBy: metadata.updatedBy ? metadata.updatedBy : null,
    };
  }

  return reservation;
}

export function toDto(reservation: AnyReservation): ReservationDto | SeatedReservationDto {
  const { uuid, placeUuid, date, realTime, numberOfGuests, layoutType, guest, reservationState, origin, metadata, specialRequest, duration } = reservation;
  const { seating, reservationEvent, timeInterval } = reservation as SeatedReservation;

  const reservationDto: ReservationDto | SeatedReservationDto = {
    uuid,
    placeUuid,
    date: date.toISOString(),
    realTime,
    numberOfGuests,
    layoutType,
    reservationState,
    origin,
    guest: toReservationGuestDto(guest),
    duration,
    seating: seating ? toReservationSeatingDto(seating) : undefined,
    timeInterval: timeInterval
      ? {
          startDate: timeInterval.startDate.toISOString(),
          endDate: timeInterval.endDate.toISOString(),
        }
      : null,
    reservationEvent: reservationEvent ? toReservationEventDto(reservationEvent) : undefined,
    specialRequest,
  };

  if (metadata) {
    reservationDto.metadata = {
      createdAt: metadata.createdAt,
      updatedAt: metadata.updatedAt,
      createdBy: metadata.createdBy ? metadata.createdBy : null,
      updatedBy: metadata.updatedBy ? metadata.updatedBy : null,
    };
  }

  return reservationDto;
}
